import React from "react";
import { Link } from "react-router-dom";
import CategoryCardGrid from "../../ui/CategoryCardGrid";
import Image1 from "../../../images/Image1.jpg";
import Image7 from "../../../images/Image7.jpeg";
import hwgh from "../../../images/Howwegothere.jpeg";
import kindnessProm from "../../../images/kindness-prom.jpg";
import Image5 from "../../../images/Image5.jpg";

// Past Projects Data
const pastProjectCards = [
  { to: "./nutrition", image: Image1, title: "Community & Nutrition" },
  { to: "./education", image: hwgh, title: "Education" },
  { to: "./arts", image: Image7, title: "Arts" },
  { to: "./hangouts", image: Image5, title: "Kindness Hangouts" },
];

const Projects = () => (
  // Reduced vertical padding (pb-6) and space between sections to remove empty areas
  <div className="pt-10 pb-6 space-y-12 lg:space-y-16">
    
    {/* KU Volunteering Section - Tighter Side-by-Side Layout */}
    <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
      <div className="flex flex-col md:flex-row items-center justify-center gap-8 lg:gap-12">
        
        {/* Left Side: Heading & Subtitle */}
        <div className="md:w-1/2 text-center md:text-left">
          <h2 className="text-4xl md:text-5xl font-extrabold text-[#5a3889] tracking-tight">
            KU Volunteering
          </h2>
          <p className="text-gray-600 text-lg mt-3">
            Explore our current focus
          </p>
        </div>

        {/* Right Side: Single Custom Card */}
        <div className="md:w-1/2 flex justify-center md:justify-start w-full">
          <Link 
            to="./WKW" 
            className="block w-full max-w-[320px] rounded-[24px] overflow-hidden bg-white shadow-[0_8px_24px_rgba(0,0,0,0.08)] hover:shadow-[0_12px_32px_rgba(0,0,0,0.12)] transition-all duration-300"
          >
            {/* Image with Purple Gradient Overlay */}
            <div className="relative aspect-[4/3]">
              <img 
                src={kindnessProm} 
                alt="Volunteering" 
                className="w-full h-full object-cover" 
              />
              <div className="absolute inset-0 bg-gradient-to-t from-[#5a3889]/90 via-[#5a3889]/30 to-transparent"></div>
              <h3 className="absolute bottom-6 w-full text-center text-white text-2xl font-bold px-4">
                Volunteering
              </h3>
            </div>
            {/* Bottom Explore Bar */}
            <div className="py-4 flex justify-center items-center text-[#5a3889] font-bold text-sm">
              Explore <span className="ml-2 font-normal">→</span>
            </div>
          </Link>
        </div>

      </div>
    </div>

    {/* Past Projects Section */}
    <div>
      <CategoryCardGrid
        title="Past Projects"
        subtitle="A look back at our previous kindness engagements across various categories."
        cards={pastProjectCards}
        columns={4}
        align="center"
      />
    </div>

  </div>
);

export default Projects;